import { Box, Flex, Progress } from '@chakra-ui/react';
import { getPercentage } from '../../../utils/helper';

interface RatingBarProps {
    title: string;
    value: number;
}

export default function RatingBar({ title, value }: RatingBarProps) {
    return (
        <Flex flex={1} alignItems="center">
            <Box paddingRight={4} width={150}>
                {title}
            </Box>
            <Flex flex={1} alignItems="center">
                <Box flex={1}>
                    <Progress color="yellow" value={getPercentage(value, 5)} />
                </Box>
                <Box fontWeight="bold" paddingLeft={4}>
                    {value.toFixed(1)}
                </Box>
            </Flex>
        </Flex>
    );
}
